<template>
  <div>
    <el-dialog
      v-if="dialogVisible"
      title="相似/同款商品"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1100px"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <div class="ccui-multifunctional-table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableData"
          :fit="true"
          border
          class="ccui-multifunctional-table"
          @selection-change="handleSelectionChange"
          :min-height="427"
        >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column label="商品" :width="60">
            <template slot-scope="{ row }">
              <div>
                <img
                  :src="row.skuOssUrl | goodsPicFormat"
                  style="width:54px;height:54px;"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="商品标题"
            :min-width="250"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              <span
                style="cursor:pointer;color:#405DEC;text-decoration: underline;"
                @click="goDetail(row)"
                >{{ row.skuName }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="商品编码"
            :min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              {{ row.skuId }}
            </template>
          </el-table-column>
          <el-table-column
            label="起订量"
            :min-width="80"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              {{ row.minPurchaseNum }}
            </template>
          </el-table-column>
          <el-table-column
            label="销售价"
            :min-width="130"
            :show-overflow-tooltip="true"
            align="right"
          >
            <template slot-scope="{ row }">
              <span class="low-price-label" v-if="row.isLower">最低价</span>
              <span>￥{{ row.price | toMoneyFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="商品状态"
            :min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              {{ row.skuStatus | toSkuStatusStr }}
            </template>
          </el-table-column>
          <el-table-column label="选购数量" :min-width="140">
            <template slot-scope="{ row, $index }">
              <el-input-number
                style="width:120px;"
                v-model="row.num"
                :min="row.minPurchaseNum"
                :max="row.maxPurchaseNum"
                @change="handleChange($event, row, $index)"
                size="mini"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作" :min-width="110">
            <template slot-scope="{ row }">
              <el-button
                size="mini"
                type="primary-font-mini"
                @click="handleAdd(row)"
                >加入购物车</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { numCheck } from "@/api/emc-api";
import { deepClone } from "@/utils/index";

export default {
  name: "sameGoods",
  data() {
    return {
      tableData: [],
      selected: [],
      tableLoading: false,
      dialogVisible: false,
      flag: true
    };
  },
  props: ["defaultArea"],
  watch: {},
  mounted() {},
  methods: {
    goDetail(row) {
      const VUE_APP_EMI_URL = this.$addUrlPerFix(process.env.VUE_APP_EMI_URL);
      window.open(`${VUE_APP_EMI_URL}${row.skuId}`);
    },
    showModal(rows) {
      this.tableData = deepClone(
        rows.map(v => {
          v.minPurchaseNum = v.minPurchaseNum ? +v.minPurchaseNum : 1;
          v.maxPurchaseNum = v.maxPurchaseNum ? +v.maxPurchaseNum : 99999;
          v.num = v.minPurchaseNum;
          v.old = v.num;
          return v;
        })
      );
      this.dialogVisible = true;
    },
    handleChange(e, row, index) {
      console.log("handleChange", index);
      this.flag = false;
      const checkNumdata = {
        // isShowLoading: true,
        skuId: row.skuId,
        num: e,
        provinceCode: this.defaultArea[0].code + "",
        cityCode: this.defaultArea[1].code + "",
        countyCode: this.defaultArea[2].code + "",
        streetCode: this.defaultArea.length > 3 ? this.defaultArea[3].code : "0"
      };
      numCheck(checkNumdata)
        .then(res => {
          this.flag = true;
          if (res.data.code == "0") {
            this.$set(this.tableData[index], "old", e);
          }
        })
        .catch(err => {
          this.flag = true;
          this.$set(this.tableData[index], "num", row.old);
        });
    },
    handleAdd(row) {
      if (this.flag) {
        this.$emit("success", row);
        this.handleClose();
      }
    },
    handleSelectionChange(val) {
      this.selected = val;
    },
    handleClose() {
      this.dialogVisible = false;
      this.selected = [];
      this.tableData = [];
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.low-price-label {
  border-radius: 4px;
  border: 1px solid #34ac2c;
  font-size: 12px;
  padding: 1px 6px;
  color: #34ac2c;
  user-select: none;
  // margin-left: 15px;
  // margin-right: 10px;
}
/deep/.el-input-number__decrease,
/deep/.el-input-number__increase {
  background: #fff;
  &.is-disabled {
    background: #e5e5e5;
  }
}
.ccui-multifunctional-table {
  padding: 20px 0;
}

/deep/.ccui-multifunctional-table-wrapper
  .el-table
  tbody
  tr
  td:first-child
  .cell {
  height: 60px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
</style>
